export function isObject(value: unknown): boolean {
  return typeof value === 'object' && value !== null && !Array.isArray(value) && !(value instanceof Date)
}

export function getValueForKey<T extends object, K extends string>(obj: T, key: K): any {
  const keys: string[] = key.split('.')

  let current: any = obj

  for (const k of keys) {
    const isLastKey = keys.indexOf(k) === keys.length - 1

    if (!isLastKey && isObject(current[k])) {
      current = current[k]
    } else if (isLastKey && !isObject(current[k])) {
      current = current[k]
    } else {
      current = k
    }
  }

  return current
}
